import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "toolbar",
  id: "kt_toolbar"
}
const _hoisted_2 = {
  "data-kt-swapper": "true",
  "data-kt-swapper-mode": "prepend",
  "data-kt-swapper-parent": "{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}",
  class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
}
const _hoisted_3 = { class: "d-flex align-items-center text-dark fw-bolder my-1 fs-3" }
const _hoisted_4 = {
  key: 0,
  class: "h-20px border-gray-200 border-start mx-4"
}
const _hoisted_5 = {
  key: 1,
  class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1"
}
const _hoisted_6 = { class: "breadcrumb-item pe-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_9 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "d-flex align-items-center py-1" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "kt_toolbar_container",
      class: _normalizeClass([{
        'container-fluid': _ctx.toolbarWidthFluid,
        'container-xxl': !_ctx.toolbarWidthFluid,
      }, "d-flex flex-stack"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  class: "text-muted text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("li", {
                    class: _normalizeClass(["breadcrumb-item", item.active ? 'text-dark' : 'text-muted'])
                  }, [
                    (item.path && item.path != null && item.path != '')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: item.path, params: { id: item.id}},
                          class: "text-muted text-hover-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ], 64))
                  ], 2),
                  (_ctx.breadcrumbs.length - 1 !== index)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_9, _hoisted_11))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionButtons, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (( item.isAllowed == false || item.isDisplay == false) ? false : true)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: _normalizeClass(["btn", item.class ?? item.class]),
                  onClick: ($event: any) => (_ctx.setActionButtonEmit(item.action))
                }, [
                  (item.iconClass)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(item.iconClass)
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(item.name), 1),
                  (item.isLoader)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_13))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ], 2)
  ]))
}